import { Header } from '@/components/Layout/Header/Header';
import { ExPremiumList } from '@/components/Views/Finance/ExPremiumList';

export const ExPremium = () => {
  return (
    <div className="flex flex-col max-h-screen">
      <Header title="Ex prenium" userName="Mas Aly" role="Admin" goBack />
      <ExPremiumList />
    </div>
  );
};
